module.exports = __webpack_public_path__ + "static/floppy-3e12cf43da6dd4395e24f56eb0f116c7.svg";